import { render, staticRenderFns } from "./ConnexionsBDD.vue?vue&type=template&id=aef71ff4"
import script from "./ConnexionsBDD.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnexionsBDD.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports